<template>
 <div>
    <div class="row">
      <div class="col-md-6" v-for="(option, index) in optionsToSelect" :key="index">
        <div
          class="form-inline align-items-center m-2"
          :class="{'other-option-line': option.id == other}"
        >
          <check-box
            class="mr-2"
            v-model="option.isSelected"
            :text="option.name"
            :disabled="isReadOnly"
          />
          <ValidationProvider
            v-if="option.id == other"
            v-slot="{ errors }"
            :ref="`otherInput${option.id}`"
            :name="`otherInput${option.id}`"
            :rules="`${!option.isSelected || isReadOnly ? '' : 'required'}`"
          > 
            <custom-input
              v-if="option.id == other"
              v-model="otherInput"
              type="text"
              :disabled="!option.isSelected || isReadOnly"
              maxlength="50"
              class="custom-input-other custom-text-field ml-2"
              placeholder="Especifique"
              :error="errors[0]"
              custom-error-msg="Favor especificar documento en Otra."
            />
          </ValidationProvider>
        </div>
      </div>
      <p class="error-p ml-3" v-if="!existSelected && isValidated"><em class="fa fa-times-circle"></em> Seleccione al menos una dificultad</p>
    </div>
     <div class="row">
      <div class="col-md-12">
       <b class="form-inline align-items-center">Una vez se reciba la(s) evaluación(es), el COMPU se reunirá por 
      <ValidationProvider ref="quantitySelector"v-slot="{ errors }" name="Documento" rules="required"> 
       <custom-drop-down
          v-model="meetingQty"
          class="size-drop-down mr-2 ml-2"
          fieldkey="id"
          fieldname="name"
          :value="meetingQty"
          :options="getMeetingQuantities"
          :disabled="isReadOnly"
          :error="errors[0]"
          custom-error-msg=""
          :placeholder="'Seleccione'"
        /> 
        </ValidationProvider>
        ocasión con el propósito de reevaluar la información disponible e iniciar el proceso de análisis de la información nuevamente
        de análisis de la información nuevamente.</b>
        <br>
        <p class="error-p ml-3" v-if="!quantityValidation.valid && isValidated && !meetingQty"><em class="fa fa-times-circle"></em> Favor de especificar la cantidad de reuniones que se llevaron a cabo para determinar la elegibilidad. (22080)</p>
      </div>
    </div>
  </div>
</template>

<script>

import CheckBox from "CheckBox";
import CustomInput from "@/components/common/CustomInput";
import CustomDropDown from 'custom-drop-down';
const OTHER=8;
export default {
    name: "DocumentsByDIfficulty",
    components: {
    CheckBox,
    CustomInput,
    CustomDropDown
  },
  watch: {
    optionsToSelect: {
      deep: true, 
      handler(newVal, oldVal) {
        const selectedValues = newVal.filter((option) => option.isSelected === true);

        if (selectedValues.filter(x => x.id == this.other).length == 0) {
          this.otherInput = "";
        }
        
        this.$emit('difficultyList',selectedValues)
      },
    },
    otherInput: {
      deep: true, 
      handler(newVal, oldVal) {
        this.$emit('optionOther',newVal)
      },
    },
    meetingQty: {
      deep: true, 
      handler(newVal, oldVal) {
        this.$emit('getQuantity',newVal.id)
      },
    },
    existDifficulySelected: {
      deep: true, 
      handler(newVal, oldVal) {
        this.existInfoSelected=newVal
      },
      immediate: true,
    },
    reevaluationTime:{
      deep: true, 
      handler(newVal, oldVal) {

        this.meetingQty =newVal?{name:newVal}: this.meetingQty
      },
      immediate: true,
    },
  },
  props: {
    options: {
      type: Array,
      default: []
    },
    reevaluationTime:{
      type: Number,
      default: 0
    },
    existDifficulySelected:{
      type: Array,
      default: []
    },
    isFromDetailCoordination:{
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      difficultyDocuments:[],
      optionsToSelect:[],
      existInfoSelected:[],
      otherInput:null,
      meetingQty:null,
      other:OTHER,
      isValidated:false,
      quantityValidation: { valid: false },
      otherInputValidation: { valid: false },
    };
  },
  methods: {
    async validateForm() {
      this.quantityValidation = await this.$refs.quantitySelector.validate();
      this.otherInputValidation = await this.$refs[`otherInput${this.other}`][0].validate();
      this.isValidated = true;

      return (this.quantityValidation.valid & this.existSelected & this.otherInputValidation.valid);
    },
    getInfoFiltered(){
      this.existSelected
      const updatedOptions = this.optionsToSelect.map(option => {
        const matchingData = this.existInfoSelected.find(item => item.academicDifficultyProgressTypeId === option.id);
        if (matchingData) {
          option.isSelected = true;
          if (matchingData.comment) {
            this.otherInput = matchingData.comment;
          }
        }
        return option;
      });
    },   
  },
  computed: {
    existSelected(){
      return this.optionsToSelect.some(element => element.isSelected === true)
    },
    getMeetingQuantities() {
      let items = [];
      for (let i = 1; i <= 10; i++) {
        items.push({ id: i, name: i.toString() });
      }
      return items;
    },
    isReadOnly(){
      return this.existInfoSelected.length>0 && !this.isFromDetailCoordination
    },
   getOptions(){
    return this.options;
   },
   getQty(){
    return this.reevaluationTime
   }
  },
  async mounted() {
  this.optionsToSelect= this.getOptions.map((item) => ({
      ...item,
      isSelected: false,
    }));
    this. getInfoFiltered()
  }
};
</script>
<style scoped  lang="scss">

::v-deep input[type="checkbox"]:checked + label span {
  background-color: #2db782 !important;
}

::v-deep input[type="checkbox"]:checked + label span em {
  filter: brightness(0) invert(1);
}

.other-option-line {
  display: flex;
  align-items: flex-start !important;
}

.custom-input-other{
  width: 300px
}

.form-control[data-v-3315f7b6]:disabled {
    background: #fff;
    cursor: not-allowed;
}

.custom-text-field {
  ::v-deep .form-control:disabled {
    background: #F5F5F5 !important;
  }
}
.size-drop-down{
  width: 131px;
}
.error-p {
  color: #ff5b5c;
}
</style>
